<div class="dialog-content-min">
    <form [formGroup]="SubdepartmentForm">
        <div class="formgrid grid">
            <div [ngClass]="tssprtlimitedaccess == 'N' ? 'field col-11' : 'field col-12'">
                <label class="required-label" for="departmentid">Department<span >*</span></label>
                <p-dropdown [options]="departmentList" [filter]="true" appendTo="body" optionLabel="departmentname"
                    optionValue="departmentid" formControlName="departmentid" inputId="departmentid"
                    placeholder="Select Department" name="departmentid"></p-dropdown>
                <span style="color:red" class="errormessage"
                    *ngIf="SubdepartmentForm.get('departmentid').invalid && (SubdepartmentForm.get('departmentid').dirty || SubdepartmentForm.get('departmentid').touched)">
                    {{getErrorMessage(SubdepartmentForm ,validation_message,'departmentid')}}
                </span>
            </div>
            <div  *ngIf="tssprtlimitedaccess == 'N'" class="field col-1" style="color:red; margin-top: 20px;margin-left: -10px;">
                 <p-button (click)="addDepartment('Add Department','')"  pTooltip="Add Department" tooltipPosition="left"
                    styleClass="customAdd p-button-sm p-button-raised mr-4 " icon="fa fa-plus"></p-button>
            </div>
        </div>
        <div class="formgrid grid">
            <div class="field col-12">
                <label for="subdepartmentname">{{this.subdeptLabel}} Name</label>
                <label for="pagemodal" class="required-label">
                    <span style="color: rgb(60, 137, 246);font-size:9px !important;">(Max 200 chars)</span><span class="required-label">*</span>
                </label>
                <textarea autoResize="true" rows="3" class="form-control" id="subdepartmentname" inputId="subdepartmentname"
                    placeholder="Enter {{this.subdeptLabel}} Name" name="subdepartmentname" formControlName="subdepartmentname"
                    pInputText required></textarea>
                <span style="color:red" class="errormessage"
                    *ngIf="SubdepartmentForm.get('subdepartmentname').invalid && (SubdepartmentForm.get('subdepartmentname').dirty || SubdepartmentForm.get('subdepartmentname').touched)">
                    {{getErrorMessage(SubdepartmentForm ,validation_message,'subdepartmentname')}}
                </span>
            </div>
        </div>
    </form>
</div>
<div class="custom-dialog-footer">
    <p-button class="m-1" label="Close" styleClass="customeclose" (click)="dismiss()"></p-button>
    <p-button class="m-1" label="{{saveTitle}}" styleClass="customesave" (click)="addSubdepartment()"></p-button>
</div>